// src/components/PostCard/PostCard.js
import React from "react";
import { Card, Space, Tag, Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

export default function PostCard({ post, keyword = "", className = "", style }) {
  const navigate = useNavigate();
  const normalize = (value) => String(value || "");
  const highlight = (text) => {
    const raw = normalize(text);
    if (!keyword) return raw;
    const lower = raw.toLowerCase();
    const q = keyword.toLowerCase();
    const idx = lower.indexOf(q);
    if (idx === -1) return raw;
    const before = raw.slice(0, idx);
    const hit = raw.slice(idx, idx + q.length);
    const after = raw.slice(idx + q.length);
    return (
      <>
        {before}
        <mark className="text-highlight">{hit}</mark>
        {after}
      </>
    );
  };

  return (
    <Card
      hoverable
      className={`glass-card ${className}`.trim()}
      style={{
        marginBottom: 16,
        borderRadius: 16,
        border: "1px solid var(--card-border)",
        background: "var(--card-bg)",
        boxShadow: "var(--card-shadow)",
        backdropFilter: "var(--card-blur)",
        width: "100%",
        ...style,
      }}
      bodyStyle={{
        padding: "16px 18px",
        background: "var(--card-body-bg)",
        borderRadius: 14,
      }}
      title={
        <Space direction="vertical" size={2}>
          <Typography.Text
            strong
            style={{
              fontSize: 16,
              letterSpacing: 0.5,
              color: "var(--text-primary)",
            }}
          >
            {highlight(post.title)}
          </Typography.Text>
          <Typography.Text
            type="secondary"
            style={{ fontSize: 12, color: "var(--text-secondary)" }}
          >
            {dayjs(post.createdAt).format("YYYY-MM-DD HH:mm")}
          </Typography.Text>
        </Space>
      }
      extra={
        <Button
          type="text"
          onClick={() => navigate(`/post/${post.id}`)}
          style={{
            padding: "0 6px",
            color: "var(--tag-color)",
            fontWeight: 500,
          }}
        >
          查看
        </Button>
      }
    >
      <Typography.Paragraph
        style={{ marginBottom: 10, color: "var(--text-primary)" }}
      >
        {post.summary ? highlight(post.summary) : highlight(post.content?.slice(0, 80))}
      </Typography.Paragraph>

      <Space wrap>
        {post.category ? (
          <Tag
            style={{
              borderRadius: 999,
              border: "1px solid var(--tag-border)",
              background: "var(--tag-bg)",
              color: "var(--tag-color)",
            }}
          >
            {post.category}
          </Tag>
        ) : null}
        {(post.tags || []).map((t) => (
          <Tag
            key={t}
            style={{
              borderRadius: 999,
              border: "1px solid var(--tag-border)",
              background: "var(--tag-bg)",
              color: "var(--tag-color)",
            }}
          >
            {t}
          </Tag>
        ))}
      </Space>
    </Card>
  );
}
